import type { TicketAttachmentDTO } from "@zplanem/responses"

export function canDeleteTicketAttachment(
	attachment: TicketAttachmentDTO,
	viewerId: string | undefined,
	canManageTickets: boolean,
): boolean {
	if (canManageTickets) return true
	return viewerId != null && attachment.uploadedBy === viewerId
}
